import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateEdgeData, clearSelection as clearEdgeSelection, bumpClearTick, setEdgesActionCreator, selectSingleEdge, setEdgeSelectionSquelchUntil } from '../../../../../redux/reducers/global/edge/edgeSlice';
import { setTabPanel } from '../../../../../redux/reducers/global/editor/editorSlice';
import { EDITOR_TAB_PANEL_ELEMENTS, EDITOR_TAB_PANEL_INSPECTOR } from '../../../../../utilities/constants/editorConstants';

const ConnectingCableInspector = () => {
  const dispatch = useDispatch();
  const edges = useSelector((state) => state.edge.edges) || [];
  const selectedEdgeIds = useSelector((state) => state.edge.selectedEdgeIds) || [];
  const selectedEdgeId = selectedEdgeIds[0];
  const edge = edges.find((e) => e.id === selectedEdgeId);
  const noEdge = !edge;
  const data = edge?.data || {};
  const ensureAttr = (attr, fallbackValue, label) => {
    const userModified = attr?.visibilityUserModified === true;
    return {
      value: attr?.value ?? fallbackValue,
      label: attr?.label ?? label,
      isVisible: userModified ? !!attr?.isVisible : true,
      visibilityUserModified: userModified,
    };
  };
  const sourceAttrs = (data && typeof data.attributes === 'object') ? data.attributes : {};
  const attrs = {
    calibre: ensureAttr(sourceAttrs?.calibre, data.calibre || '', 'Calibre'),
    marca: ensureAttr(sourceAttrs?.marca, data.marca || '', 'Marca'),
    numConductoresPorFase: ensureAttr(
      sourceAttrs?.numConductoresPorFase,
      data.numConductoresPorFase || '',
      '# de conductores por fase'
    ),
    longitud: ensureAttr(sourceAttrs?.longitud, data.longitud || '', 'Longitud'),
    canalizacion: ensureAttr(sourceAttrs?.canalizacion, data.canalizacion || '', 'Canalización'),
  };

  React.useEffect(() => {
    // removed noisy mount/render logs
  }, [selectedEdgeId, attrs?.calibre?.value, attrs?.calibre?.isVisible, attrs?.marca?.value, attrs?.marca?.isVisible]);

  const upsert = (nextAttrs) => {
    const flat = {
      calibre: nextAttrs.calibre?.value,
      marca: nextAttrs.marca?.value,
      numConductoresPorFase: nextAttrs.numConductoresPorFase?.value,
      longitud: nextAttrs.longitud?.value,
      canalizacion: nextAttrs.canalizacion?.value,
    };
    // upsert change
    if (!edge) return;
    dispatch(updateEdgeData({ edgeId: edge.id, data: { ...flat, attributes: nextAttrs } }));
    // Keep edge selected and inspector open while editing
    dispatch(selectSingleEdge(edge.id));
    dispatch(setTabPanel({ tabPanel: EDITOR_TAB_PANEL_INSPECTOR }));
    // Prevent selection-change callbacks from clearing selection for a brief window
    dispatch(setEdgeSelectionSquelchUntil(Date.now() + 400));
  };

  const handleValueChange = (field, value) => {
    const next = { ...attrs, [field]: { ...(attrs[field] || {}), value } };
    // value change
    upsert(next);
  };

  const handleVisibilityToggle = (field) => {
    const prev = attrs[field]?.isVisible;
    const next = {
      ...attrs,
      [field]: {
        ...(attrs[field] || {}),
        isVisible: !prev,
        visibilityUserModified: true,
      },
    };
    // visibility toggle
    upsert(next);
  };

  return (
    <div className="ctn-inspector">
      <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
        <button
          type="button"
          className="modal-btn large"
          onClick={() => {
            if (!selectedEdgeId) return;
            const next = edges.filter((e) => e.id !== selectedEdgeId);
            dispatch(setEdgesActionCreator({ edges: next }));
            dispatch(clearEdgeSelection());
            dispatch(setTabPanel({ tabPanel: EDITOR_TAB_PANEL_ELEMENTS }));
            dispatch(bumpClearTick());
          }}
        >
          Borrar línea
        </button>
      </div>
    </div>
  );
};

export default ConnectingCableInspector;
